import { createNavLink } from "./navigation-utils.js";

export default function initMobileNav(state) {
  const nav = document.querySelector(".sz-main-nav");
  const container = nav?.querySelector(".container");
  const toggle = document.querySelector(".sz-mobile-toggle");
  const backdrop = document.querySelector(".sz-nav-backdrop");

  if (!nav || !container || !toggle || !state?.tree) return;

  /* -----------------------------------------
     STATE
  ----------------------------------------- */

  const stack = []; // keeps navigation history

  /* -----------------------------------------
     BUILD PANEL
  ----------------------------------------- */

  function buildPanel(items, parentLabel = null) {
    const panel = document.createElement("div");
    panel.className = "sz-mobile-panel";
    panel._items = items;
    panel._label = parentLabel;

    const header = document.createElement("div");
    header.className = "sz-mobile-panel__header";

    // TOP ROW
    const topRow = document.createElement("div");
    topRow.className = "sz-mobile-panel__header-top";

    const title = document.createElement("div");
    title.className = "sz-mobile-panel__title";
    title.textContent = parentLabel || state.section?.label || "Menu";

    const closeBtn = document.createElement("button");
    closeBtn.className = "sz-mobile-panel__close";
    closeBtn.setAttribute("aria-label", "Close menu");
    closeBtn.innerHTML = "✕";
    closeBtn.addEventListener("click", closeNav);

    topRow.appendChild(title);
    topRow.appendChild(closeBtn);

    // BOTTOM ROW (only if not root)
    header.appendChild(topRow);

    if (stack.length > 0) {
      const backRow = document.createElement("div");
      backRow.className = "sz-mobile-panel__header-bottom";

      const backBtn = document.createElement("button");
      backBtn.className = "sz-mobile-panel__back";

      const parent = stack.at(-1);
      const rootLabel = state.section?.label || "Menu";

      backBtn.innerText = parent ? `← ${parent.label}` : `← ${rootLabel}`;

      backBtn.addEventListener("click", popPanel);

      backRow.appendChild(backBtn);
      header.appendChild(backRow);
    }

    panel.appendChild(header);

    // List
    const ul = document.createElement("ul");
    ul.className = "sz-mobile-panel__list";

    items.forEach((item) => {
      const li = document.createElement("li");

      const hasChildren = item.children?.length;

      /* const link = document.createElement("a");
      link.href = item.url;
      link.textContent = item.label;
      link.className = "sz-mobile-panel__link"; */
      const link = createNavLink({
        url: item.url,
        label: item.label,
        className: "sz-mobile-panel__link",
      });

      if (hasChildren) {
        const btn = document.createElement("button");
        btn.className = "sz-mobile-panel__forward";
        btn.setAttribute("aria-label", `Open ${item.label}`);
        li.classList.add("has-children");

        btn.addEventListener("click", () => {
          pushPanel(item.children, item.label);
        });

        li.appendChild(link);
        li.appendChild(btn);
      } else {
        li.appendChild(link);
      }

      ul.appendChild(li);
    });

    panel.appendChild(ul);

    return panel;
  }

  /* -----------------------------------------
     RENDER
  ----------------------------------------- */

  const panels = [];
  let isAnimating = false;

  function getTrack() {
    return container.querySelector(".sz-mobile-track");
  }

  function focusCurrentPanel() {
    const current = panels[panels.length - 1];
    if (!current) return;

    const first = current.querySelector(".sz-mobile-panel__link");
    if (first) first.focus();
  }

  function setTrackPosition(index, animate = true) {
    const track = getTrack();
    if (!track) return;

    if (!animate) {
      track.classList.add("no-animate");
    }

    track.style.transform = `translateX(-${index * 100}%)`;

    if (!animate) {
      requestAnimationFrame(() => {
        track.classList.remove("no-animate");
      });
    }
  }

  function renderRoot() {
    stack.length = 0;
    panels.length = 0;
    isAnimating = false;

    const panel = buildPanel(state.tree, state.section?.label || "Menu");
    panels.push(panel);

    const track = document.createElement("div");
    track.className = "sz-mobile-track no-animate";
    track.appendChild(panel);

    container.replaceChildren(track);

    setTrackPosition(0, false);
  }

  function pushPanel(items, label) {
    if (isAnimating) return;

    const track = getTrack();
    if (!track) return;

    const currentPanel = panels.at(-1);

    stack.push({
      items: currentPanel?._items || state.tree,
      label: currentPanel?._label || state.section?.label || "Menu",
    });

    const panel = buildPanel(items, label);
    panels.push(panel);

    track.appendChild(panel);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        isAnimating = true;
        setTrackPosition(panels.length - 1, true);

        const onDone = (e) => {
          if (e.propertyName !== "transform") return;
          track.removeEventListener("transitionend", onDone);
          isAnimating = false;
          focusCurrentPanel();
        };

        track.addEventListener("transitionend", onDone);
      });
    });
  }

  function popPanel() {
    if (isAnimating) return;
    if (panels.length <= 1) return;

    const track = getTrack();
    if (!track) return;

    isAnimating = true;

    setTrackPosition(panels.length - 2, true);

    const panelToRemove = panels[panels.length - 1];

    const onDone = (e) => {
      if (e.propertyName !== "transform") return;
      track.removeEventListener("transitionend", onDone);

      panelToRemove.remove();
      panels.pop();
      const previous = stack.pop();

      isAnimating = false;
      focusCurrentPanel();
    };

    track.addEventListener("transitionend", onDone);
  }
  /* -----------------------------------------
     OPEN / CLOSE
  ----------------------------------------- */

  function openNav() {
    nav.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
    document.body.classList.add("nav-open");
    document.body.style.overflow = "hidden";

    if (backdrop) backdrop.hidden = false;

    renderRoot();
  }

  function closeNav() {
    nav.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("nav-open");
    document.body.style.overflow = "";
    stack.length = 0;

    if (backdrop) backdrop.hidden = true;

    toggle.focus();
  }
  toggle.onclick = null;
  toggle.addEventListener("click", () => {
    nav.classList.contains("is-open") ? closeNav() : openNav();
  });

  if (backdrop) {
    backdrop.addEventListener("click", closeNav);
  }

  document.onkeydown = (e) => {
    if (e.key === "Escape") {
      closeNav();
    }
  };
}
